import Icons from '../../components/Menu/Icons';

const isFeatureEnabled = (value) => value === true || value === 1;

const menuItemsUserMaster = [
  {
    title: "Cadastro",
    subItems: [
      { title: 'Dados do cliente', slug: 'dados-cliente' },
      { title: 'Usuários', slug: 'usuarios' },
    ]
  },
  {
    title: "Financeiro",
    subItems: [
      // { title: 'Preços', slug: 'precos' },
      { title: 'Relatório de consumo', slug: 'relatorio' },
      { title: 'Segunda via de boleto', slug: 'segunda-via-boleto' }
    ]
  },
  {
    title: 'Operacional',
    subItems: [
      {title: 'Locações', slug: 'solicitacao'}
    ]
  },
  {
    title: 'BI (v.beta)',
    pathSegment: 'bi',
    subItems: [
      { title: 'Extração de Dados', slug: 'extracao-dados' }
    ]
  },
  {
    title: 'Suporte',
    subItems: [
      {title: `(21)98734-6472`, slug: 'wpp', icon: Icons.WPP()},
      // {title: `(21)2222-4998`, slug: 'tel', icon: Icons.Telefone()},
      {title: `fcanalise@fichacerta.com.br`, slug: 'email', icon: Icons.Email()},
    ]
  }
]

const menuItemsSemParecer = [
  {
    title: "Cadastro",
    subItems: [
      { title: 'Dados do cliente', slug: 'dados-cliente' },
      { title: 'Usuários', slug: 'usuarios' }
    ]
  },
  {
    title: "Financeiro",
    subItems: [
      { title: 'Relatório de consumo', slug: 'relatorio' },
      { title: 'Segunda via de boleto', slug: '' }
    ]
  },
  {
    title: 'Operacional',
    subItems: [
      {title: 'Locações', slug: 'solicitacao'}
    ]
  },
  {
    title: 'Suporte',
    subItems: [
      {title: `(21)98734-6472`, slug: 'wpp', icon: Icons.WPP()},
      // {title: `(21)2222-4998`, slug: 'tel', icon: Icons.Telefone()},
      {title: `fcanalise@fichacerta.com.br`, slug: 'email', icon: Icons.Email()},
    ]
  }
]

const buildMenuForUser = (usuario) => {
  if (!usuario?.master) {
    return menuItemsSemParecer;
  }

  return menuItemsUserMaster.map((section, index) => {
    if (index !== 0) {
      return section;
    }

    const subItems = [...section.subItems];

    if (isFeatureEnabled(usuario.recomendacao_ativada)) {
      subItems.push({ title: 'Regras de Aprovação', slug: 'customizar-pareceres' });
    }

    return { ...section, subItems };
  });
};

export { menuItemsSemParecer, menuItemsUserMaster, buildMenuForUser };